import Cookies from 'js-cookie'

export default class CookieStorage
{
    constructor(namespace, name) {
        this.key = namespace + '_' + name;
        this.namespace = namespace;
    }

    /**
     * Get payload
     * @returns {mixed|null}
     */
    get() {
        let payload = Cookies.get(this.key);
        return payload ? JSON.parse(payload) : null;
    }

    /**
     * Set payload storage
     *
     * @param payload
     * @param  ttl: the expiration in milliseconds (!!)
     * @returns this
     */
    set(payload, ttl = false) {
        let option = {};
        if (ttl) {
            let now = new Date();
            option.expires = new Date(now.getTime() + ttl);
        }
        Cookies.set(this.key, JSON.stringify(payload), option);
        return this;
    }

    /**
     * 
     * @param  payload 
     * @param  ttl: the expiration in milliseconds (!!)
     * @returns this
     */
    setex(payload, ttl) {
        this.set(payload, ttl);
        return this;
    }

    /**
     * Delete all namespaced cookie
     * @returns this
     */
    deleteNamespace() {
        if (this.storage === undefined) {
            return;
        }

        for (let key in Cookies.get()) {
            if (key.substr(0, this.namespace.length + 1) == (this.namespace + '_')) {
                Cookies.remove(key);
            }
        }
        return this
    }

    /**
     * Delete storage
     * @returns this
     */
    delete() {
        Cookies.remove(key);
        return this;
    }
}